import React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer className="w-full bg-gray-900 text-gray-300 py-10 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 pb-5">

        {/* Copyright */}
        <div className="text-sm">
          <p>
            © {t("footer.date")} {t("footer.company")}. {t("footer.allRights")}
          </p>
        </div>

        {/* Disclaimer */}
        <div className="text-sm md:text-right">
          <p>
            {t("footer.disclaimer")}
          </p>
        </div>

      </div>
    </footer>
  );
}